// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_cv-3";
export var flatBottomCorners = "_cv-5";
export var productImage = "_cv-0";
export var quantityContainer = "_cv-2";
export var quantityHeader = "_cv-6";
export var tooltip = "_cv-1";
export var wrapAndEllipsesOverflow = "_cv-4";